import { ApiProxy, ApiCallResult } from "@infoland/api-proxy";
import snackBarService from "../../../services/snackBarService";
// state type

// getters for this store
const getters = {};

// mutations for this store
const mutations = {};

// actions for this store
const actions = {
    async getSearchSuggestions({ commit }, params): Promise<Object[] | null> {
        const path = `portals/${params.portalId}/search_suggestions?search_query=${encodeURIComponent(params.searchCriteria)}`;

        const response: ApiCallResult<Object[]> = await ApiProxy.getRequest(snackBarService.setMessage, path);
        if (response.statusCode == 200) {
            return response.result;
        } else return [];
    }
};

// export namespace
export const namespace = "suggestions";
// export the store 'module'
export default {
    namespaced: true,
    getters,
    mutations,
    actions
};
